import { render } from "./HeadingPort.vue?vue&type=template&id=f016780e&scoped=true"
import script from "./HeadingPort.vue?vue&type=script&lang=js"
export * from "./HeadingPort.vue?vue&type=script&lang=js"

import "./HeadingPort.vue?vue&type=style&index=0&id=f016780e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f016780e"

export default script